/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_85d2da0c"]'><div :class='["radio-modal-slots-demo"]'><cube-radio-modal ref="__mpx_ref_radioModal__" :show-close-icon="(true)" :options="(options)" :value="(checkedValue)"><div slot="title" :class='["modal-title"]'>标题slot</div><div slot="subtitle" :class='["modal-subtitle"]'>副标题slot</div></cube-radio-modal><cube-button @_click="onTap">radio-modal-slots</cube-button></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_85d2da0c"}'>
.modal-title
  font-size 20px
  font-weight bold
  margin-bottom 10px
.modal-subtitle
  margin-bottom 10px
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_85d2da0c"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_85d2da0c"}
  /** script content **/
  require("./radio-modal-slots.mpx.js?isComponent&outputPath=components%2Fradio-modal-slots85d2da0c%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./radio-modal-slots.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fradio-modal-slots85d2da0c%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_85d2da0c"],
    ctorType: "component",
    outputPath: "components/radio-modal-slots85d2da0c/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-radio-modal':getComponent(require("../../../packages/mpx-cube-ui/src/components/radio-modal/index.mpx?isComponent&outputPath=components%2Findex253dfa48%2Findex")),'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>